<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xjwQBi/tc-custom/9781453262108.jpg?1705548151458" alt="This image is the cover for the book Avignon Quintet, The Avignon Quintet"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Avignon Quintet, The Avignon Quintet
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>From the visionary author of the Alexandria Quartet comes a landmark five-part series </b><b>hailed by the <i>Sunday Times </i>as “one of the great novels of our time.”</b><br/><br/> One of the most celebrated English writers ever, Lawrence Durrell was a bestselling author whose vivid metafictions pushed the boundaries of modern literature. The cosmopolitan provocateur transcended borders, ideologies, and time in his work, and he’s at the height of his powers in the Avignon Quintet.<br/>  <br/> More formally daring than the Alexandria Quartet, these sweeping and stylish novels set before, during, and after World War II loosely center on the race to uncover a treasure buried by the Knights Templar. Each reveals a seemingly disparate piece of the puzzle. In <i>Monsieur</i>, it’s the bittersweet return to southern France by a British doctor; in <i>Livia</i>, it’s two sisters driven apart by the rise of Nazism in Europe. In <i>Constance</i>, a Freudian analyst struggles for clarity in a world on fire; in <i>Sebastian</i>, she reconnects with the charismatic cult leader she knew in the deserts of Egypt. And in <i>Quinx</i>, long-buried plots reemerge as the past and future are funneled into the present.<br/>  <br/> Durrell himself described the Avignon Quintet as a “quincunx,” a series of novels “roped together like climbers on a rockface, but all independent.” Together they form a powerful meditation on the search for meaning in a world of chaos and brutality.<br/>  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lawrence Durrell
      </h2>
      
      <p class="authorDescription body article">Born in Jalandhar, British India, in 1912 to Indian-born British colonials, Lawrence Durrell was a critically hailed and beloved novelist, poet, humorist, and travel writer best known for the Alexandria Quartet novels, which were ranked by the Modern Library as among the greatest works of English literature in the twentieth century. A passionate and dedicated writer from an early age, Durrell&rsquo;s prolific career also included the groundbreaking Avignon Quintet, whose first novel, <i>Monsieur </i>(1974), won the James Tait Black Memorial Prize, and whose third novel, <i>Constance </i>(1982), was nominated for the Booker Prize. He also penned the celebrated travel memoir <i>Bitter Lemons of Cyprus </i>(1957), which won the Duff Cooper Prize. Durrell corresponded with author Henry Miller for forty-five years, and Miller influenced much of his early work, including a provocative and controversial novel, <i>The Black Book </i>(1938). Durrell died in France in 1990. &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?51fa5819